import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const ModerationSection = styled(Segment.Group)`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  margin: 0 !important;
`;

export const ModerationSectionActions = styled(Segment)`
  flex-shrink: 0;
`;

export const ModerationSectionContent = styled(Segment)`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;
